import envList from '../../../constants/envList';
import ProductType from '../../../constants/ProductType';
import RtMaxService from '../../../services/rtMaxService';

export function prepareState(res, preselect, isoValue, env) {
  switch (env) {
    case envList.CA.path:
    case envList.IME.path: {
      const {
        adhesifs,
        entreChevrons,
        entreChevronsItem,
        masticPrice,
        mastics,
        membranePriceRtmax,
        membraneRtmax,
        membranesItemRtmax,
        selectedAdhesif,
        sousChevronsItem,
        sousChevronsRtmax,
        suspentesItem,
        suspentesRtmax,
      } = RtMaxService.getProducts(res, preselect, isoValue, env);

      const costs = RtMaxService.calculateCost([
        {
          type: ProductType.BETWEEN_CHEVRON,
          productData: entreChevronsItem,
        },
        {
          type: ProductType.UNDER_CHEVRON,
          productData: sousChevronsItem,
        },
        {
          type: ProductType.MEMBRANE,
          productData: membranesItemRtmax,
        },
        {
          type: ProductType.SHROUD,
          productData: suspentesItem,
        },
        {
          type: ProductType.ADHESIVE,
          productData: selectedAdhesif,
        },
        {
          type: ProductType.MASTIC,
          productData: {
            quantity: Math.ceil((isoValue * 0.5) / 12),
            price: masticPrice,
          },
        },
      ], isoValue, env);

      const {
        adhesive,
        betweenChevron,
        mastic: masticCost,
        membrane: membraneCost,
        shroud,
        solidouble,
        underChevron,
      } = costs;

      return {
        ...adhesive,
        ...betweenChevron,
        ...masticCost,
        ...membraneCost,
        ...shroud,
        ...solidouble,
        ...underChevron,
        adhesifPriceRtmax: adhesifs.price,
        entreChevronsItem,
        entreChevronsOptions: entreChevrons,
        masticPrice,
        masticrtMaxPrice: mastics.price,
        membraneOptions: membraneRtmax,
        membranePareVapeurRtmax: isoValue * membranesItemRtmax.m2perpiece,
        membranePriceRtmax,
        membranesItemRtmax,
        selectedAdhesif,
        sousChevronsItem,
        sousChevronsOptions: sousChevronsRtmax,
        suspentesItem,
        suspentesOptions: suspentesRtmax,
      };
    }
    case envList.CP.path: {
      const {
        insulators,
        insulatorsSecond,
        adhesives,
        membranes,
        selectedInsulator,
        selectedInsulatorSecond,
        selectedMembrane,
        selectedAdhesive,
        selectedMastic,
      } = RtMaxService.getProducts(res, preselect, isoValue, env);

      const cost = RtMaxService.calculateCost(
        [
          {
            productData: selectedInsulator,
            type: ProductType.INSULATOR_BETWEEN,
          },
          {
            productData: selectedInsulatorSecond,
            type: ProductType.INSULATOR_SECOND,
          },
          {
            productData: selectedMembrane,
            type: ProductType.MEMBRANE,
          },
          {
            productData: selectedAdhesive,
            type: ProductType.ADHESIVE,
          },
          {
            productData: selectedMastic,
            type: ProductType.MASTIC,
          },
        ],
        isoValue,
        env,
      );

      const {
        insulatorBetween,
        insulatorSecond,
        membrane,
        adhesive,
        mastic,
      } = cost;

      return {
        ...insulatorBetween,
        ...insulatorSecond,
        ...membrane,
        ...adhesive,
        ...mastic,
        insulators,
        insulatorsSecond,
        adhesives,
        membranes,
        selectedInsulator,
        selectedInsulatorSecond,
        selectedMembrane,
        selectedAdhesive,
        selectedMastic,
      };
    }
    default:
      return null;
  }
}

export function onChangeFactory(key, that, previous) {
  return (val) => {
    that.setState({
      [key]: {
        ...previous,
        price: val,
        noFormat: true,
      },
    });
  };
}

export function onBlurFactory(key, that, previous, type, isoValue, env) {
  return () => {
    const { [key]: data } = RtMaxService.calculateCost(
      [
        {
          productData: previous,
          type,
        },
      ],
      isoValue,
      env,
    );
    that.setState({ ...data });
  };
}



// WEBPACK FOOTER //
// ./src/components/Protected/rtmax/utils.js